import { ArticleReferencesBlockProps } from "/Models/Generated/ArticleReferencesBlockProps";
import { ArticleReferenceItemProps } from "/Models/Generated/ArticleReferenceItemProps";
import { useState } from "react";
import { CaretDownIcon, CaretUpIcon, ContentArea } from "/App.Components";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import "./ArticleReferencesBlock.scss";

const ArticleReferencesBlock = ({ items }: ArticleReferencesBlockProps) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className="article-references-block-norad">
      {items.map((item, idx) => (
        <ArticleReferenceItem
          key={item.label + idx.toString()}
          label={item.label}
          text={item.text}
        />
      ))}
    </div>
  );
};

const ArticleReferenceItem = ({ label, text }: ArticleReferenceItemProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="article-references-block-norad__item">
      <button
        className="article-references-block-norad__item__button"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {isOpen ? (
          <CaretUpIcon size="24" thickness="Reg" />
        ) : (
          <CaretDownIcon size="24" thickness="Reg" />
        )}
        <span>{label}</span>
      </button>
      {isOpen && (
        <ContentArea
          contentAreaType={ContentAreaType.RichText}
          richText={{ theme: "articlereferences", breakWord: true }}
          {...text}
        ></ContentArea>
      )}
    </div>
  );
};

export default ArticleReferencesBlock;
